import { render } from "./WalletIcon.vue?vue&type=template&id=9075ca46"
const script = {}
script.render = render

export default script